import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';

const View2 = (_, { fm, formValues, onChange }) => {
  const followedPlan = path(['rehab6', 'followedPlan'], formValues);

  const controlStepData = {
    currentStatus: path(['rehab5', 'currentStatus'], formValues),
    clearlyWorseStatus: path(['rehab5', 'clearlyWorseStatus'], formValues),
    nearFutureTarget: path(['rehab5', 'nearFutureTarget'], formValues),
    betterStatus: path(['rehab5', 'betterStatus'], formValues),
    clearlyBetterStatus: path(['rehab5', 'clearlyBetterStatus'], formValues),
  };

  const currentStatusSelected = path(['rehab6', 'currentStatusSelected'], formValues);

  const onChangeSelected = name => {
    onChange({ currentStatusSelected: name });
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm(`onlineRehabilitation.rehab6.2.header`)}</h2>
            <br />
            <div>{fm(`onlineRehabilitation.rehab6.2.${!followedPlan ? 'textNegative' : 'textPositive'}`)}</div>
            <br />
            <ControlSteps
              steps={controlStepData}
              checkedValue={currentStatusSelected || 'nothingSelected'}
              onCheck={onChangeSelected}
              cognition
              fm={fm}
            />
          </div>
        }
      />
    </React.Fragment>
  );
};

View2.contextTypes = {
  fm: func,
  formValues: object,
  onChange: func,
};
export default View2;
